import { useState } from "react";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
const Rating = ({ rating, limit, onChange, disabled, className }) => {
  const [value, setValue] = useState(parseInt(rating) || 0);

  const handleChange = (newValue) => {
    if (disabled) return;
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <div className={`w-100 ${className}`}>
      {[...Array(limit)].map((item, index) => (
        <span
          key={index}
          onClick={() => handleChange(index + 1)}
          className="fs-2 text-orange mx-3 cursor-pointer"
        >
          {value >= index + 1 ? <AiFillStar /> : <AiOutlineStar />}
        </span>
      ))}
    </div>
  );
};

export default Rating;
